/**
 * Parse a skill id to a name
 * @param id - The id to parse
 * @returns The name of the skill, capitalized and spaces replaced with hyphens
 */
export const parseSkillIdToName = (id: string): string => {
  return id.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};
